import React from "react";
import "./NotificationItem.css";

const TYPE_META = {
  onboarding: { label: "Welcome Onboard 👋", icon: "🎉", accent: "#4f8ef7" },
  reminder: { label: "Reminder", icon: "🔔", accent: "#f7c34f" },
  tip: { label: "Tips", icon: "💡", accent: "#4fc28e" },
};

const timeAgo = (date) => {
  const diff = Math.floor((Date.now() - new Date(date)) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

const Avatar = ({ user }) => {
  if (user?.avatar) {
    return <img src={user.avatar} alt={user.name} className="ni-avatar ni-avatar--img" />;
  }
  return (
    <div
      className="ni-avatar ni-avatar--initials"
      style={{ background: user?.color || "#4f8ef7" }}
    >
      {user?.initials || "?"}
    </div>
  );
};

const SystemIcon = ({ type }) => {
  const meta = TYPE_META[type] || {};
  return (
    <div
      className="ni-avatar ni-avatar--system"
      style={{ background: meta.accent || "#4f8ef7" }}
    >
      <span>{meta.icon}</span>
    </div>
  );
};

const NotificationItem = ({ notification, onRead, onRemove }) => {
  const { id, type, user, body, title, timestamp, read } = notification;
  const isSystem = type !== "user";
  const meta = TYPE_META[type] || {};

  const handleClick = () => {
    if (!read) onRead(id);
  };

  return (
    <div
      className={`ni-item${read ? "" : " ni-item--unread"}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
      aria-label={`Notification: ${body}`}
    >
      <div className="ni-avatar-col">
        {isSystem ? <SystemIcon type={type} /> : <Avatar user={user} />}
        {!read && <span className="ni-unread-dot" aria-hidden="true" />}
      </div>

      <div className="ni-content">
        {isSystem && <p className="ni-label">{title || meta.label}</p>}
        {!isSystem && user && <p className="ni-sender">{user.name}</p>}
        <p className="ni-body">{body}</p>
        <span className="ni-time">{timeAgo(timestamp)}</span>
      </div>

      <button
        className="ni-action"
        aria-label="Dismiss notification"
        onClick={(e) => {
          e.stopPropagation();
          onRemove(id);
        }}
      >
        ×
      </button>
    </div>
  );
};

export default NotificationItem;
